import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchPayouts = createAsyncThunk(
  "payout/fetchPayouts",
  async (_, thunkAPI) => {
    try {
      const res = await api.get(`/api/payouts`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch payouts"
      );
    }
  }
);

export const updatePayoutStatus = createAsyncThunk(
  "payout/updatePayoutStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      const res = await api.patch(`/api/payouts/${id}/status`, { status });
      return res.data?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to update payout"
      );
    }
  }
);

const payoutSlice = createSlice({
  name: "payout",
  initialState: {
    payouts: [],
    loading: false,
    error: null,
    updatingId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayouts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayouts.fulfilled, (state, action) => {
        state.loading = false;
        state.payouts = action.payload?.data || [];
      })
      .addCase(fetchPayouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePayoutStatus.pending, (state, action) => {
        state.updatingId = action.meta.arg.id;
      })
      .addCase(updatePayoutStatus.fulfilled, (state, action) => {
        state.updatingId = null;
        const updated = action.payload;
        if (updated) {
          state.payouts = state.payouts.map((p) =>
            p._id === updated._id ? updated : p
          );
        }
      })
      .addCase(updatePayoutStatus.rejected, (state, action) => {
        state.updatingId = null;
        state.error = action.payload;
      });
  },
});

export default payoutSlice.reducer;